import { useGlobalData } from "@/app/global_data"
import { ButtonSorting } from "@/components/buttons/button.sorting"
import { ComparisonGroupTableHeaderProps } from "@/components/comparison_group_list/types"

export function TableHeader({
  sortOrder,
  onClickSorting,
}: ComparisonGroupTableHeaderProps) {
  const globalData = useGlobalData()
  const { entity } = globalData.get()

  return (
    <tr
      className={`sticky top-0 flex place-items-start bg-main-300 px-2 text-base font-semibold text-main-600`}>
      <th className="flex cursor-pointer items-center gap-2 py-1 font-bold text-main-dark">
        <ButtonSorting
          columnName="value"
          className="flex items-center gap-0.5 !bg-main-300 !px-0"
          sortOrder={sortOrder}
          onClick={() => onClickSorting("value")}
          text={"#"}
        />
      </th>
      <th className="flex flex-1 cursor-pointer items-center gap-2 py-1 font-bold text-main-dark">
        <ButtonSorting
          columnName="name"
          className="flex items-center gap-0.5  !bg-main-300"
          sortOrder={sortOrder}
          onClick={() => onClickSorting("name")}
          text={entity.isFirm() ? "Firm" : "Fund"}
        />
      </th>
      <th className="flex cursor-pointer items-center gap-2 py-1 font-bold text-main-dark">
        <ButtonSorting
          columnName="value"
          className="flex items-center gap-0.5  !bg-main-300 !px-0"
          sortOrder={sortOrder}
          onClick={() => onClickSorting("value")}
        />
      </th>
    </tr>
  )
}
